module.exports = __webpack_public_path__ + "media/images/nav/icon_10-29fbffa39dc64548757a76a88d7b89f2.svg";